// extracted by mini-css-extract-plugin
export default {"container":"ResetPasswordPage_container__x5WPz"};